/**
 * src/modules/dashboard/componentes/npsredes.js
 */

import React from 'react';
import './npsind.scss';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush
} from 'recharts';
import { IcoArchive } from '../../../components';

// Ícones personalizados para o eixo X
export const CustomTickNew = ({ x, y, payload }) => {
  if (payload.value === 'Facebook') {
    return (
      <svg x={x - 13} y={y} width="26" height="26" fill="black" viewBox="0 0 16 16">
        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
      </svg>
    );
  }
  if (payload.value === 'Instagram') {
    return (
      <svg x={x - 13} y={y} width="26" height="26" fill="black" viewBox="0 0 512 512">
        <path d="M256,0c141.29,0 256,114.71 256,256c0,141.29 -114.71,256 -256,256c-141.29,0 -256,-114.71 -256,-256c0,-141.29 114.71,-256 256,-256Zm0,96c-43.453,0 -48.902,0.184 -65.968,0.963c-17.03,0.777 -28.661,3.482 -38.839,7.437c-10.521,4.089 -19.444,9.56 -28.339,18.455c-8.895,8.895 -14.366,17.818 -18.455,28.339c-3.955,10.177 -6.659,21.808 -7.437,38.838c-0.778,17.066 -0.962,22.515 -0.962,65.968c0,43.453 0.184,48.902 0.962,65.968c0.778,17.03 3.482,28.661 7.437,38.838c4.089,10.521 9.56,19.444 18.455,28.34c8.895,8.895 17.818,14.366 28.339,18.455c10.178,3.954 21.809,6.659 38.839,7.436c17.066,0.779 22.515,0.963 65.968,0.963c43.453,0 48.902,-0.184 65.968,-0.963c17.03,-0.777 28.661,-3.482 38.838,-7.436c10.521,-4.089 19.444,-9.56 28.34,-18.455c8.895,-8.896 14.366,-17.819 18.455,-28.34c3.954,-10.177 6.659,-21.808 7.436,-38.838c0.779,-17.066 0.963,-22.515 0.963,-65.968c0,-43.453 -0.184,-48.902 -0.963,-65.968c-0.777,-17.03 -3.482,-28.661 -7.436,-38.838c-4.089,-10.521 -9.56,-19.444 -18.455,-28.339c-8.896,-8.895 -17.819,-14.366 -28.34,-18.455c-10.177,-3.955 -21.808,-6.66 -38.838,-7.437c-17.066,-0.779 -22.515,-0.963 -65.968,-0.963Zm0,28.829c42.722,0 47.782,0.163 64.654,0.933c15.6,0.712 24.071,3.318 29.709,5.509c7.469,2.902 12.799,6.37 18.397,11.969c5.6,5.598 9.067,10.929 11.969,18.397c2.191,5.638 4.798,14.109 5.509,29.709c0.77,16.872 0.933,21.932 0.933,64.654c0,42.722 -0.163,47.782 -0.933,64.654c-0.711,15.6 -3.318,24.071 -5.509,29.709c-2.902,7.469 -6.369,12.799 -11.969,18.397c-5.598,5.6 -10.928,9.067 -18.397,11.969c-5.638,2.191 -14.109,4.798 -29.709,5.509c-16.869,0.77 -21.929,0.933 -64.654,0.933c-42.725,0 -47.784,-0.163 -64.654,-0.933c-15.6,-0.711 -24.071,-3.318 -29.709,-5.509c-7.469,-2.902 -12.799,-6.369 -18.398,-11.969c-5.599,-5.598 -9.066,-10.928 -11.968,-18.397c-2.191,-5.638 -4.798,-14.109 -5.51,-29.709c-0.77,-16.872 -0.932,-21.932 -0.932,-64.654c0,-42.722 0.162,-47.782 0.932,-64.654c0.712,-15.6 3.319,-24.071 5.51,-29.709c2.902,-7.468 6.369,-12.799 11.968,-18.397c5.599,-5.599 10.929,-9.067 18.398,-11.969c5.638,-2.191 14.109,-4.797 29.709,-5.509c16.872,-0.77 21.932,-0.933 64.654,-0.933Zm0,49.009c-45.377,0 -82.162,36.785 -82.162,82.162c0,45.377 36.785,82.162 82.162,82.162c45.377,0 82.162,-36.785 82.162,-82.162c0,-45.377 -36.785,-82.162 -82.162,-82.162Zm0,135.495c-29.455,0 -53.333,-23.878 -53.333,-53.333c0,-29.455 23.878,-53.333 53.333,-53.333c29.455,0 53.333,23.878 53.333,53.333c0,29.455 -23.878,53.333 -53.333,53.333Zm104.609,-138.741c0,10.604 -8.597,19.199 -19.201,19.199c-10.603,0 -19.199,-8.595 -19.199,-19.199c0,-10.604 8.596,-19.2 19.199,-19.2c10.604,0 19.201,8.596 19.201,19.2Z"/>
      </svg>
    );
  }
  if (payload.value === 'TikTok') {
    return (
      <svg x={x - 13} y={y} width="26" height="26" fill="black" viewBox="0 0 512 512">
        <path d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM385.62,232.382c-27.184,0-53.634-8.822-74-23.75l-.162,101.5a92.457,92.457,0,1,1-80.178-91.721v49.845a43.657,43.657,0,1,0,31.288,41.876V109.333h51.275a71.773,71.773,0,0,0,71.774,71.773Z"/>
      </svg>
    );
  }
  if (payload.value === 'Youtube') {
    return (
      <svg x={x - 13} y={y} width="26" height="26" fill="black" viewBox="0 0 512 512">
        <path d="M256,0c141.29,0 256,114.71 256,256c0,141.29 -114.71,256 -256,256c-141.29,0 -256,-114.71 -256,-256c0,-141.29 114.71,-256 256,-256Zm153.315,178.978c-3.68,-13.769 -14.522,-24.61 -28.29,-28.29c-24.958,-6.688 -125.025,-6.688 -125.025,-6.688c0,0 -100.067,0 -125.025,6.688c-13.765,3.68 -24.61,14.521 -28.29,28.29c-6.685,24.955 -6.685,77.024 -6.685,77.024c0,0 0,52.067 6.685,77.02c3.68,13.769 14.525,24.614 28.29,28.293c24.958,6.685 125.025,6.685 125.025,6.685c0,0 100.067,0 125.025,-6.685c13.768,-3.679 24.61,-14.524 28.29,-28.293c6.685,-24.953 6.685,-77.02 6.685,-77.02c0,0 0,-52.069 -6.685,-77.024Zm-185.316,125.025l0,-96.002l83.137,48.001l-83.137,48.001Z"/>
      </svg>
    );
  }
  if (payload.value === 'Twitter') {
    return (
      <svg x={x - 13} y={y} width="66" height="66" fill="black" viewBox="0 0 256 256">
        <path d="M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z"/>
      </svg>
    );
  }
  if (payload.value === 'Geral') {
    return (
      <text x={x - 13} y={y + 10} fill="black" fontSize="12px">
        Geral
      </text>
    );
  }
  return null;
};


// ✅ Tooltip sem %
const CustomTooltip = ({ active, payload, label, labels, dadonaodisponivel }) => {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="custom-tooltip">
      <p className="label">{label}</p>
      {payload.map(({ name, value, color, payload: rawData }, i) => {
        const labelItem = labels.find(l => l.type === name);
        const entry = rawData?.item?.[i];
        let displayValue = value;

        if (entry?.info === -1) {
          displayValue = dadonaodisponivel;
        } else if (value === 0) {
          displayValue = '0';
        }

        return (
          <p key={`tooltip-${name}`} className="desc">
            <span style={{ backgroundColor: color }}></span>
            {`${labelItem?.name || name}: ${displayValue}`}
          </p>
        );
      })}
    </div>
  );
};

const RenderLegend = ({ labels }) => (
  <div className="custom-legend legend-center">
    {labels.map((label, i) => (
      <div key={`legend-${i}`}>
        <span style={{ backgroundColor: label.color }}></span>
        {label.name}
      </div>
    ))}
  </div>
);

// ✅ CustomLabel igual ao do npscliente.js
const CustomLabel = ({ x, y, width, value }) => {
  if (value === null || value === undefined) return null;
  const displayValue = value === 0 ? '0' : value;
  return (
    <text
      x={x + width / 2}
      y={value < 0 ? y + 16 : y}
      dy={-4}
      textAnchor="middle"
      fill="#6c7293"
      fontSize="11px"
    >
      {displayValue}
    </text>
  );
};

// ✅ Opções atualizadas: sem %, domínio [-100, 100]
const graficoOptions1 = {
  BarChart: { margin: { top: 40, right: 40, left: 20, bottom: 60 } },
  CartesianGrid: { stroke: '#e6e6e6', vertical: false },
  Brush: { dataKey: 'name', height: 30, stroke: '#dc143c', startIndex: 0, endIndex: 5 },
  XAxis: { dataKey: 'name', fontSize: '12px', stroke: '#6c7293', axisLine: false, tickLine: false },
  YAxis: { 
    fontSize: '12px', 
    stroke: '#6c7293', 
    axisLine: false, 
    tickLine: false,
    domain: [-100, 100],
    ticks: [-100, -50, 0, 50, 100]
  },
  Bar: { radius: [6, 6, 6, 6] }
};

export default function NpsInd({
  nls = {},
  componentNls = {},
  filtros = [],
  payloadData = {},
  totaldata
}) {
  const rawData = payloadData?.data || [];
  const labels = payloadData?.labels || [];
  const analise = payloadData?.analise || [];
  const dadonaodisponivel = componentNls?.dadonaodisponivel || 'No available data';

  const transformData = (rawData) => {
    if (!rawData || !Array.isArray(rawData)) return [];
    return rawData.map(item => {
      const result = { name: item.name, item: item.item };
      item.item.forEach(entry => {
        result[entry.chave] = parseFloat(entry.valor);
      });
      return result;
    });
  };

  

  const chartData = transformData(rawData);
  const hasData = chartData.length > 0 && labels.length > 0;



  return (
    <>
    <section className="box-content-like npsredes-wrapper">
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="npsredes-grafico">
        {hasData ? (
          <ResponsiveContainer width="100%" height={500}>
            <BarChart data={chartData} margin={graficoOptions1.BarChart.margin}>
              <CartesianGrid stroke={graficoOptions1.CartesianGrid.stroke} vertical={graficoOptions1.CartesianGrid.vertical} />
              {chartData.length > 5 && (
                <Brush
                  dataKey={graficoOptions1.Brush.dataKey}
                  height={graficoOptions1.Brush.height}
                  stroke={graficoOptions1.Brush.stroke}
                  startIndex={graficoOptions1.Brush.startIndex}
                  endIndex={Math.min(graficoOptions1.Brush.endIndex, chartData.length - 1)}
                />
              )}
              <XAxis {...graficoOptions1.XAxis} tick={<CustomTickNew />} />
              <YAxis {...graficoOptions1.YAxis} />
              <Tooltip content={<CustomTooltip labels={labels} dadonaodisponivel={dadonaodisponivel} />} />
              <Legend content={<RenderLegend labels={labels} />} />
              {labels.map((label) => (
                <Bar
                  key={`bar-${label.type}`}
                  dataKey={label.type}
                  fill={label.color}
                  radius={graficoOptions1.Bar.radius}
                  label={<CustomLabel />}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="npsredes-no-data">
            {componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'No data'}
          </div>
        )}
      </div>


      {analise.length > 0 && (
        <div className="npsredes-analise">
          <h3>
            <IcoArchive style={{ width: 20, height: 20, marginRight: 8 }} />
            {componentNls?.analise || 'Analysis'}
          </h3>
          <div className="analise-content">
            {analise.map((item, idx) => (
              <div key={idx} className="analise-item">
                <strong>{item.topico}:</strong> {item.texto}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
INPUT JSON:

 {
      "nls": {
        "analise": "Analysis",
        "dadonaodisponivel": "No available data",
        "semdadosparaexibir": "No data"
      },
      "label": "Nps Redes",
      "scope": {
        "periodo": {
          "fim": "2025-09-30",
          "ini": "2025-09-01"
        },
        "projetoId": 46
      },
      "params": {
        "idiomaId": 2,
        "empresaId": 225,
        "comparacao": "true"
      },
      "Filtros": [
        {
          "nomedofiltro": "Empresa",
          "valordofiltro": "McDonald´s"
        }
      ],
      "ordinal": 11,
      "topicKey": "npsredes"
    }


*/




